import * as React from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { Alert } from "@mantine/core";
import { bindActionCreators } from "redux";
import { getPersonByUsername } from "../../data/actions/personActions";
import PersonApi from "../../data/api/personsApi";
import { IPerson } from "../../types/persons/person";
import { ProfilePage } from "./PersonalProfilePage";

interface IProfilePageProps {
  match: object;
  actions: {
    getPersonByUsername: (username: string) => Promise<IPerson>;
  };
}

const RoutedProfilePage: React.FunctionComponent<IProfilePageProps> = (props) => {
  const { id } = useParams();
  const [person, setPerson] = React.useState<IPerson | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);


  React.useEffect(() => {

    props.actions.getPersonByUsername(id).then(person => {
      setPerson(person);
      PersonApi.getFullPersonById(person._id).then(({ person }) => {
        setPerson(person);
      }).catch(err => {
        setError(err.message);
      });
      setLoading(false);
    }).catch(err => {
      setError(err.message);
      setLoading(false);
    });
  }, [id]);

  if (!id || error) {
    return <Alert color="red">{error || "No username provided"}</Alert>;
  }

  if (loading || !person) {
    return <p>Loading...</p>;
  }


  return (
    <ProfilePage person={person} hideDashboard hideTimesheet defaultTab="Appointments" />);
};

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ getPersonByUsername }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RoutedProfilePage);
